export default "__VITE_ASSET__DTmnhrks__"